<template>
  <div class="container">
      <br><br>
    <card>
      <div class="card-bpdy">
        <div v-if="this.sessid !== 'LOGOUT'">
          <div v-if="!failed"><h3><i class="fa-solid fa-spinner"></i>{{$t('Authentication_in_progress_Please_wait')}}</h3></div>
          <div v-if="failed"><h3><i class="fa-solid fa-ban"></i>{{$t('Invalid_token')}}</h3></div>
        </div>
        <div v-if="this.sessid === 'LOGOUT'"><h3><i class="fa-solid fa-hourglass-end"></i>{{$t('Session_has_expired')}}</h3></div>
      </div>
    </card>
  </div>
</template>

<script>
import { Auth } from "../services/user";
import { GenerateToken } from "../services/crypto";
import { AuthUser } from "../services/localstate";
export default {
  props: {
    id: String,
  },
  data() {
    return {
      failed: false,
      sessid: this.id,
    };
  },
  mounted() {
    this.failed = false;
    this.$store.dispatch("logout");
    if (this.sessid && this.sessid !== "LOGOUT") {
      Auth(this.sessid).then((response) => {
        if (response.data) {
          AuthUser(response.data, GenerateToken(), GenerateToken());
          this.$router.push({
            path: "/dashboard",
          });
        } else {
          this.failed = true;
        }
      });
    } else {
      this.failed = true;
    }
  },
  watch: {
    id() {
      this.sessid = this.id;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>